import { Routes } from '@angular/router';
import { homeRedirectGuard } from './core/guards/auth.guard';
import { AuthorizationComponent } from './features/authorization/components/pcl-authorization/authorization';
import { DebugLayoutComponent } from './debug-layout';

/**
 * Root route configuration.
 *
 * - `/ppn-auth`  PPN authorization (UAT / production) or the login form when `environment.isDev` (one component).
 * - `/app`       authenticated shell (header + page). Pages are guarded by role permissions:
 *     Non-Admin: `/app/vehicle-statement/new`, `/app/vehicle-statement/view/:statementId`
 *     Admin:     `/app/statements`, `/app/statements/view/:statementId`,
 *                `/app/users`, `/app/users/add`, `/app/users/update/:userId`
 * - everything else falls back to `/app`, which redirects to the role's landing page.
 */
export const routes: Routes = [
  { path: '', redirectTo: 'ppn-auth', pathMatch: 'full' },
  { path: 'ppn-auth', component: AuthorizationComponent, title: 'Authorization' },
  { path: 'debug', component: DebugLayoutComponent },
  {
    path: 'app',
    loadComponent: () => import('./layout/layout').then((m) => m.LayoutComponent),
    children: [
      // Landing page depends on the role (first permitted menu entry)
      { path: '', pathMatch: 'full', canActivate: [homeRedirectGuard], children: [] },
      {
        path: 'vehicle-statement',
        loadChildren: () =>
          import('./features/vehicle-statement/vehicle-statement.routes').then(
            (m) => m.vehicleStatementRoutes,
          ),
      },
      {
        path: 'statements',
        loadChildren: () =>
          import('./features/admin/vehicle-statements/vehicle-statements.routes').then(
            (m) => m.vehicleStatementsRoutes,
          ),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./features/admin/user-management/user-management.routes').then(
            (m) => m.userManagementRoutes,
          ),
      },
    ],
  },
  { path: '**', redirectTo: 'app' },
];
